import React from 'react';
import LoginView from './LoginView';

class HomePublic extends React.Component
{
  render()
  {
    return (
      <>
        <div className="flex-row home-frame">
          <svg id="home-logo" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 1024"
            preserveAspectRatio="xMidYMid meet">
            <image href="/assets/img/logo/logo_1024.jpg" />
          </svg>
          <LoginView />
        </div>
      </>
    );
  }

}

export default HomePublic;